import { useMutation } from "react-query";
import { NOTIFICATIONS } from "~/constans/notifications";
import { useTranslation } from "react-i18next";
import { useAddNotificationMutation } from "~/schemas/generated/graphql";
import { useDealer } from "./useDealer";
import { UpdateBlockQualityIProps } from "../model/schema";
import { getQuarter } from "date-fns";

export default function useUpdateBlockQuality() {
  const { updateBlockQuality } = useDealer();
  const [addNotificationMutation] = useAddNotificationMutation({});
  const { t } = useTranslation();
  const date = new Date();
  const quarterNow = getQuarter(date);
  const updateData: UpdateBlockQualityIProps = {
    year: date.getUTCFullYear(),
    quarter: quarterNow,
  };
  return useMutation({
    mutationFn: () => updateBlockQuality(updateData),
    onError: (error) => console.log(error),
    onSuccess: () => {
      addNotificationMutation({
        variables: {
          type: NOTIFICATIONS.success,
          content: t("common.indicators_update_start"),
        },
      });
    },
  });
}
